/* Vector Space (kwvector.space) — landing page behaviour.
 *
 * The page is fully server-rendered; this bundle only adds icon rendering
 * (lucide replaces <i data-lucide="..."> with inline SVG) and the header's
 * scrolled state. Form controls are native inputs styled with CSS.
 */

import {
    createIcons,
    Accessibility,
    Armchair,
    ArrowRight,
    Building2,
    Calendar,
    CalendarDays,
    Check,
    Clock,
    ConciergeBell,
    Cpu,
    DoorOpen,
    ExternalLink,
    Globe,
    Images,
    Mail,
    MapPin,
    Megaphone,
    MessageSquareReply,
    Navigation,
    PencilRuler,
    Phone,
    Projector,
    ShieldCheck,
    SoapDispenserDroplet,
    Table2,
    User,
    Users,
} from 'lucide';

import './vectorspace-calendar.js';

createIcons({
    icons: {
        Accessibility, Armchair, ArrowRight, Building2, Calendar, CalendarDays, Check, Clock,
        ConciergeBell, Cpu, DoorOpen, ExternalLink, Globe, Images, Mail, MapPin,
        Megaphone, MessageSquareReply, Navigation, PencilRuler, Phone, Projector,
        ShieldCheck, SoapDispenserDroplet, Table2, User, Users,
    },
});

const header = document.querySelector('.vs-header');
if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 24);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
}

// After a failed submission the page re-renders with errors; bring the form
// back into view (successful submissions land on #apply via the redirect).
if (document.querySelector('.vs-form-errors')) {
    document.getElementById('apply')?.scrollIntoView();
}
